/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 11:10:03
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 10:33:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/tools.ts
 */
import { cloneDeep } from 'lodash';

function dfsOptions(node, nodeList, path?) {
  if (node) {
    const { uuid, childNodes: children = [], urlSlug, name } = node;

    nodeList.push({
      value: uuid,
      urlSlug,
      label: name,
      path: path || [],
    });
    for (let i = 0; i < children.length; i++) {
      const _path = path ? [...path, uuid] : [uuid];
      dfsOptions(children[i], nodeList, _path);
    }
  }
  return nodeList;
}

function deepTraversal(node, nodeList, dataSet, path, allNodesWithOrder) {
  if (node) {
    const { uuid, childNodes: children = [], matched, name, ...rest } = node;
    if (matched) nodeList.push(uuid);
    allNodesWithOrder.push(uuid);
    dataSet[uuid] = {
      ...rest,
      uuid,
      path,
      name: name,
    };
    const _path = [...(path || [])];
    _path.push(uuid);
    for (let i = 0; i < children.length; i++) {
      deepTraversal(children[i], nodeList, dataSet, _path, allNodesWithOrder);
    }
  }
  return nodeList;
}

const generator = ({ list, dataSet, isSearching, allNodesWithOrder }) => {
  const order = [];
  while (list.length > 0) {
    const node = list.shift();
    const nodeList = [];
    const path = [];
    const _temp = deepTraversal(
      node,
      nodeList,
      dataSet,
      path,
      allNodesWithOrder,
    );
    // order.push(isSearching?..._temp:);
    if (isSearching) {
      order.push(..._temp);
    } else {
      order.push(_temp);
    }
  }
  return order;
};

const _convertDataFromServerToRedux = (data, isSearching) => {
  const { childNodes, matched, ...rest } = data;
  const _list = cloneDeep(childNodes || []);
  const root = rest;
  const { uuid, name } = root;
  const dataSet = {};
  dataSet[uuid] = { ...root, name: name };
  const allNodesWithOrder = [uuid];
  const order = generator({
    list: _list,
    dataSet,
    isSearching,
    allNodesWithOrder,
  });

  return {
    root: matched ? uuid : null,
    dataSet,
    order,
    allNodesWithOrder,
  };
};

const convertDataFromServerToReduxNoSearch = ({
  state,
  data,
  searchingStatusHasChanged,
}) => {
  const { root, dataSet, order, allNodesWithOrder } =
    _convertDataFromServerToRedux(data, false);
  //console.log(dataSet);
  state.rootUuid = root;
  state.dataSet = dataSet;
  state.order = order;
  state.loaded = true;

  const collapseOpen = generateCollapseStatus({
    originState: state.collapseOpen,
    currentData: dataSet,
    isChangeStatus: searchingStatusHasChanged,
  });

  state.collapseOpen = collapseOpen;
  state.allNodesWithOrder = allNodesWithOrder || [];
};

const convertDataFromServerToReduxHasSearch = ({
  state,
  data,
  searchingStatusHasChanged,
}) => {
  const { root, dataSet, order, allNodesWithOrder } =
    _convertDataFromServerToRedux(data, true);

  state.rootUuid = root;
  state.dataSet = dataSet;

  state.order = order.map((i) => [i]);
  state.loaded = true;
  const collapseOpen = generateCollapseStatus({
    originState: state.collapseOpen,
    currentData: dataSet,
    isChangeStatus: searchingStatusHasChanged,
  });
  state.collapseOpen = collapseOpen;
  state.allNodesWithOrder = allNodesWithOrder || [];
};

const generateCollapseStatus = ({
  originState,
  currentData,
  isChangeStatus,
}) => {
  if (isChangeStatus) {
    return Object.keys(currentData).reduce((pre, now) => {
      return { ...pre, [now]: false };
    }, originState);
  } else {
    return Object.keys(currentData).reduce((pre, now) => {
      if (originState.hasOwnProperty(now)) {
        return pre;
      } else {
        return { ...pre, [now]: false };
      }
      //return { ...pre, [now]: false };
    }, originState);
  }
};

const hierarchyNameGenerator = (name, path) => {
  const _name =
    path.reduce((pre) => {
      const text = pre + '— ';
      return text;
    }, '') + name;
  return _name;
};
export {
  convertDataFromServerToReduxNoSearch,
  convertDataFromServerToReduxHasSearch,
  dfsOptions,
  hierarchyNameGenerator,
};
